module.exports = __webpack_public_path__ + "img/system41-mini.5dc41321.png";